import React, { useState } from 'react';

import AccountUserDetailLikeProductLogModal from './AccountUserDetailLikeProductLogModal';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import LabelInfo from '../../../../../components/LabelInfo';
import Anchor from '../../../../../components/link/Anchor';
import {
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_FILER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_SORT_OPTION_MODEL,
} from './models';
import {
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE,
  LIKE_PRODUCT_LIST_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/accountUserConstants';
import columns from './columns';
import { useAccountUserDetailLikeProductList, useAccountUserLikeProductDetail } from './hooks';
import './AccountUserDetailLikeProductInfo.scss';

const AccountUserDetailLikeProductInfo = (props) => {
  const { userId, isActive } = props;

  const [actionLogType, setActionLogType] = useState();
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => {
    setModalOpen(false);
    setActionLogType(null);
  };
  const openModal = ({ actionLogType }) => {
    setModalOpen(true);
    setActionLogType(actionLogType);
  };

  const { likeProductHistory, filterOption, sortOption, getList } = useAccountUserDetailLikeProductList({
    userId,
    isActive,
  });
  const { list, totalCnt, mainProductCategorySelectList } = likeProductHistory;

  const { totalAddCount, totalRemoveCount, totalClickCount } = useAccountUserLikeProductDetail({ userId, isActive });

  return (
    <div className="account-user-detail-content account-user-detail-like-product-content">
      <div className="account-user-detail-section">
        <div className="title">좋아요 한 상품 리스트</div>

        <div className="account-user-detail-section-content">
          <div className="form-wrap">
            <LabelInfo
              label="총 상품 클릭수"
              info={
                <Anchor
                  text={totalClickCount}
                  isUnderLine
                  color="primary"
                  onClick={() =>
                    openModal({
                      actionLogType: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.CLICK,
                    })
                  }
                />
              }
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="총 상품 좋아요 추가수"
              info={
                <Anchor
                  text={totalAddCount}
                  isUnderLine
                  color="primary"
                  onClick={() =>
                    openModal({
                      actionLogType: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.LIKE,
                    })
                  }
                />
              }
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="총 상품 좋아요 삭제수"
              info={
                <Anchor
                  text={totalRemoveCount}
                  isUnderLine
                  color="primary"
                  onClick={() =>
                    openModal({
                      actionLogType: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.UNLIKE,
                    })
                  }
                />
              }
            />
          </div>
        </div>

        <div className="account-user-detail-section-content like-product-list">
          <TableWithSummary
            className="account-user-detail-section-list"
            data={list}
            totalCnt={totalCnt}
            isStriped={true}
            emptyText={LIKE_PRODUCT_LIST_TABLE_EMPTY_TEXT}
            initialOption={{
              filterOption: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_FILER_OPTION_MODEL,
              sortOption: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_SORT_OPTION_MODEL,
            }}
            filterOption={filterOption}
            sortOption={sortOption}
            getList={getList}
            columns={(utils) =>
              columns({
                ...utils,
                mainProductCategorySelectList,
              })
            }
          />
        </div>
      </div>
      {isModalOpen && (
        <AccountUserDetailLikeProductLogModal
          userId={userId}
          actionLogType={actionLogType}
          closeModal={closeModal}
          setActionLogType={setActionLogType}
        />
      )}
    </div>
  );
};

export default AccountUserDetailLikeProductInfo;
